import React from 'react';
import { motion } from 'framer-motion';

const MapDivider = () => {
  return (
    <div className="w-full py-16 flex justify-center items-center opacity-70">
      <motion.svg 
        width="300" 
        height="40" 
        viewBox="0 0 300 40" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        initial={{ pathLength: 0, opacity: 0 }}
        whileInView={{ pathLength: 1, opacity: 1 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1.5, ease: "easeInOut" }}
      >
        <circle cx="10" cy="20" r="4" fill="#D97736" />
        <path 
          d="M 20 20 Q 75 5, 150 20 T 280 20" 
          stroke="#1E3A8A" 
          strokeWidth="2" 
          strokeDasharray="6 6" 
          fill="none" 
        />
        <path d="M 280 10 L 290 20 L 280 30 Z" fill="#D97736" />
      </motion.svg>
    </div>
  );
};

export default MapDivider;